import { withStyles } from '@material-ui/core';
import Loading from './Loading';
import styles from './Loading.styles';

export default withStyles(styles)(Loading);
